// extracted by css-extract-rspack-plugin
export default {"aiMarkdown":"Wmbhu","smartLink":"lxCWm","smartLinkInner":"MXuuw","icon":"ZdEq1"};